import { Link } from "@remix-run/react";

import { useLocalizedPath } from "~/helpers/navigationHelper";
import common from "~/i18n/common";
import { useT } from "~/i18n/useT";

/** The two interlocking rings, per the design. Decorative; the wordmark names it. */
export function LogoMark({ size = 34 }: { size?: number }) {
  return (
    <svg
      className="ss-logo__mark"
      width={size}
      height={size}
      viewBox="0 0 34 34"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="34" height="34" rx="10" fill="#2442E6" />
      <circle
        cx="15"
        cy="17"
        r="5.75"
        fill="none"
        stroke="#fff"
        strokeWidth="2.5"
      />
      <circle
        cx="20"
        cy="17"
        r="5.75"
        fill="none"
        stroke="#FF6A45"
        strokeWidth="2.5"
      />
    </svg>
  );
}

export default function Logo({
  variant = "light",
}: {
  variant?: "light" | "dark";
}) {
  const t = useT(common);
  const localize = useLocalizedPath();

  return (
    <Link
      to={localize("/")}
      className={`ss-logo ss-logo--${variant}`}
      aria-label={t.brand.name}
    >
      <LogoMark />
      <span className="ss-logo__word" aria-hidden="true">
        {t.brand.first}
        <span className="ss-logo__word-accent">{t.brand.second}</span>
      </span>
    </Link>
  );
}
